import request from '@/axios'

export function registerApi (payload) {
  return request({
    url: '/auth/ClientUser/register',
    method: 'POST',
    data:payload
  })
}

export function loginApi (payload) {
  return request({
    url: '/auth/ClientUser/login',
    method: 'POST',
    data:payload
  })
}

export function loginWithQRApi (payload) {
  return request({
    url: '/auth/ClientUser/loginWithQR',
    method: 'POST',
    data:payload
  })
}

export function logOutApi () {
  return request({
    url: '/ClientUser/logout',
    method: 'GET'
  })
}

export function resetPasswordApi (payload) {
  return request({
    url: '/ClientUser/reset_password_internal',
    method: 'POST',
    data:payload
  })
}

export function ForgotPassword (payload) {
  return request({
    url: '/auth/ClientUser/forget_password',
    method: 'POST',
    data: payload
  })
}

export function passwordSetupApi (payload) {
  return request({
    url: '/auth/ClientUser/reset_password',
    method: 'POST',
    data:payload
  })
}